export default function citySelector({main, on, elm}) {
	main(_ => {
		on('change', 'select', changeCity);
	});

	const changeCity = function (e) {
		const selectedUrl = ensureTrailingSlash(e.target.value);
		location.href = selectedUrl;
	}

	const ensureTrailingSlash = function (url) {
		if (typeof url !== 'string' || url === '') {
			return url;
		}

		const hashIndex = url.indexOf('#');
		const hash = hashIndex !== -1 ? url.slice(hashIndex) : '';
		const withoutHash = hashIndex !== -1 ? url.slice(0, hashIndex) : url;

		const queryIndex = withoutHash.indexOf('?');
		const path = queryIndex !== -1 ? withoutHash.slice(0, queryIndex) : withoutHash;
		const query = queryIndex !== -1 ? withoutHash.slice(queryIndex) : '';

		if (path.endsWith('/')) {
			return url;
		}

		return path + '/' + query + hash;
	};
};

export const model = {};
